var path = 'src/app/forms/fields/source-group-field.html';
var html = "<select frm-model frm-required ng-model=model ng-options=\"x as x.shortName for x in sourceGroups track by x.id\" ng-required=required() class=form-control></select> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/forms/fields/source-group-field.html
 ** module id = 296
 ** module chunks = 0
 **/